import { BrandType } from 'models/brand.model';
import { MealType } from 'models/meal.model';
import { PolygonType } from 'models/polygon.model';
import { EditPostType, PostType } from 'models/posts.model';
import { createContext, useContext } from 'react';

export type PostContextType = {
  initialEditData: EditPostType;
  editPostForm: EditPostType;
  setEditPostForm: (k: EditPostType) => void;
  disabled: boolean;
  setDisabled: (k: boolean) => void;
  postToEdit: PostType | null;
  setPostToEdit: (value: PostType) => void;
  postLoading: boolean;
  polygons: PolygonType[];
  brands: BrandType[];
  meals: MealType[];
};

export const EditPostContext = createContext({} as PostContextType);

const useEditPostContext = () => {
  const context = useContext(EditPostContext);
  return context;
};

export default useEditPostContext;
